module.exports = __webpack_public_path__ + "images/arrow-group-up.e77e595386656c29c6c30d9e683fda8e.png";